import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 28/18;
const HEIGHT = 18/18;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 28 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Discussions:-new-user" transform="translate(-1217.000000, -978.000000)">
                <g id="Group-43" transform="translate(366.000000, 732.000000)">
                    <g id="Right" transform="translate(0.000000, 232.000000)">
                        <g id="Group-21" transform="translate(851.000000, 14.000000)">
                            <rect id="Rectangle-17" stroke={color} strokeWidth="2" opacity="1" x="1" y="1" width="26" height="16" rx="4"></rect>
                            <text id="GIF" fontFamily="SF Pro Text" fontSize="10" fontWeight="bold" letterSpacing="-0.1333333" fill={color}>
                                <tspan x="5.76787104" y="12">GIF</tspan>
                            </text>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconGif extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}